/**
 * Parts Index
 * Registers all part factories with a PartRegistry
 */

import type { PartRegistry } from '../PartRegistry';

// Part implementations
import { createRender } from './Render';
import { createRandomJungle } from './RandomJungle';
import { createRandomDeepJungle } from './RandomDeepJungle';
import { createRandomFlower } from './RandomFlower';
import { createRandomTile } from './RandomTile';
import { createRandomColors } from './RandomColors';

// Re-export parts for direct access
export { Render, createRender } from './Render';
export { RandomJungle, createRandomJungle } from './RandomJungle';
export { RandomDeepJungle, createRandomDeepJungle } from './RandomDeepJungle';
export { RandomFlower, createRandomFlower } from './RandomFlower';
export { RandomTile, createRandomTile } from './RandomTile';
export { RandomColors, createRandomColors } from './RandomColors';

// Re-export Random class from utils
export { Random } from '@/utils/Random';

/**
 * Register all terrain parts with the given registry
 */
export function registerTerrainParts(registry: PartRegistry): void {
  registry.register('Render', createRender);
  registry.register('RandomJungle', createRandomJungle);
  registry.register('RandomDeepJungle', createRandomDeepJungle);
  registry.register('RandomFlower', createRandomFlower);
  registry.register('RandomTile', createRandomTile);
  registry.register('RandomColors', createRandomColors);
}
